import React from 'react';
import './react.css';
import {Link} from 'react-router-dom';
import {useEffect} from "react"
import ReactIcon from '../../images/react.svg';
import AOS from 'aos';
import 'aos/dist/aos.css';


function ReactBlog() {

  useEffect(() => {
    AOS.init();
  }, [])


  return (
  <section className="react-blog" id="html-blog">
   <div className="react-blog-container">
   
    <div className="react-blog-info" data-aos="fade-right">
      <img src={ReactIcon} className="react-img" alt="" />
      
      <div className="react-blog-content">
        {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/ReactIntro"><h3 className="react-main-title"> What is React? </h3></Link>
        <p className="react-blog-description"> 
        React.js is a powerful library for building dynamic, responsive, and maintainable user 
        interfaces for web applications. Its component-based architecture, virtual DOM, 
        declarative syntax, and active developer community make it a top choice for modern 
        web development. Whether you're building a simple website or a complex single-page
         application, React can help you create engaging and efficient user experiences.
          So, if you haven't already, consider adding React.js to your web development toolkit.</p>
        <Link to="/ReactIntro"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="react-blog-info" data-aos="zoom-in">
      <img src={ReactIcon} className="react-img"  alt="" />
      <div className="react-blog-content">
      {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Syntax"><h3 className="react-main-title"> JSX </h3></Link>
        <p className="react-blog-description"> 
        JSX, short for (JavaScript XML) is a syntax extension for JavaScript, most commonly used with React to describe how the UI should look. Essentially
        JSX is the syntax of react. Combining the power of JavaScript with HTML-like syntax, making it simplier to write and understand React 
        components. In this blog post, we'll delve into the fundamentals of JSX and explore its features, benefits, and best practices..</p>
        <Link to="/Syntax"><button class="button"> Read More </button></Link>
      </div>
    </div>

    <div className="react-blog-info" data-aos="fade-left">
      <img src={ReactIcon} className="react-img"  alt="" />
      <div className="react-blog-content">
      {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Components"><h3 className="react-main-title"> Components </h3></Link>
        <p className="react-blog-description"> 
        React revolves around the concept of components. Components are the building blocks of 
        React applications, encapsulating both UI elements and the logic to manage them. In this
         blog post, we'll take a deep dive into React components, exploring their types, lifecycle, 
         props, state, and best practices for building robust and scalable applications.</p>
        <Link to="/Components"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="react-blog-info" data-aos="fade-left">
      <img src={ReactIcon} className="react-img" alt="" />
      <div className="react-blog-content">
      {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Router"><h3 className="react-main-title"> React Router </h3></Link>
        <p className="react-blog-description"> 
        React Router has become an essential tool in the React ecosystem for building single-page
        applications. Its ability to manage navigation and URL changes while keeping the UI in sync
         has made it a go-to choice for developers. In this blog post, we'll dive into React Router,
          exploring its core concepts, features, and how to effectively use it in your projects.</p>
        <Link to="/Router"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="react-blog-info" data-aos="zoom-in">
      <img src={ReactIcon} className="react-img" alt="" />
      <div className="react-blog-content">
      {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Props"><h3 className="react-main-title"> Props </h3></Link>
        <p className="react-blog-description"> 
        Props are a fundamental concept that plays a crucial role in building reusable
        and modular components. Short for "properties," props allow data to be passed from a parent 
        component to its child components. In this blog post, we'll explore the ins and outs of
         props in React, from basic usage to advanced patterns, helping you harness their power
        effectively in your applications.</p>
        <Link to="/Props"><button className="button"> Read More </button></Link>
      </div>
    </div>
    
    <div className="react-blog-info" data-aos="fade-right">
      <img src={ReactIcon} className="react-img" alt="" />
      <div className="react-blog-content">
      {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/State"><h3 className="react-main-title"> State </h3></Link>
        <p className="react-blog-description"> 
        State is a fundamental concept in React that allows components to manage and track data
         that changes over time. Understanding how to effectively manage state is crucial for 
         building dynamic and interactive user interfaces. In this blog post, we'll delve deep 
         into the world of state in React, covering its fundamentals, best practices, and advanced
          patterns, empowering you to wield this powerful concept with confidence in your React
           applications.</p>
        <Link to="/State"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="react-blog-info" data-aos="fade-left">
      <img src={ReactIcon} className="react-img" alt="" />
      <div className="react-blog-content">
      {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Hooks"><h3 className="react-main-title"> Hooks </h3></Link>
        <p className="react-blog-description"> 
        With the introduction of React Hooks, managing state and side effects in functional
         components has become more powerful than ever before. Hooks allow developers to reuse 
         stateful logic across components without the need for class components or higher-order 
         components. In this blog post, we'll explore the world of React Hooks, from the basics 
         to advanced patterns, empowering you to leverage their full potential in your React 
         applications.</p>
        <Link to="/Hooks"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="react-blog-info" data-aos="zoom-in">
      <img src={ReactIcon} className="react-img" alt="" />
      <div className="react-blog-content">
      {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/ApiReact"><h3 className="react-main-title"> API </h3></Link>
        <p className="react-blog-description"> 
        React's API provides developers with a powerful toolkit for building modern and dynamic 
        user interfaces. Understanding the core APIs is essential for mastering React development 
        and crafting efficient and maintainable code. In this blog post, we'll take a deep dive
         into the essential React APIs, exploring their functionalities, use cases, and best
          practices, empowering you to leverage them effectively in your projects..</p>
        <Link to="/ApiReact"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="react-blog-info" data-aos="fade-right">
      <img src={ReactIcon} className="react-img" alt="" />
      <div className="react-blog-content">
      {/* <span className="react-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Operators"><h3 className="react-main-title"> Operators </h3></Link>
        <p className="react-blog-description"> React operators, also known as JavaScript operators,
         play a vital role in manipulating data, performing logical operations, and controlling 
         the flow of React applications. Understanding how to effectively use operators can
          significantly enhance your productivity and code readability. In this blog post, 
          we'll delve into the world of React operators, exploring their types, usage scenarios,
           and best practices, empowering you to wield them with confidence in your React projects.
       </p>
        <Link to="/Operators"><button className="button"> Read More </button></Link>
      </div>
    </div>

  </div>
</section>
  )
}

export default ReactBlog;